import { connect } from "react-redux";
import Setting from "./index";

const mapDispatchToProps = {
 
};

export default connect(null, mapDispatchToProps)(Setting);